<div class="settings-page">
  @if (!canEdit) {
    <div class="info-banner">
      <i class="bx bx-lock-alt"></i>
      <span>
        Only a restaurant admin can change these settings. Ask your admin to turn them on or off.
      </span>
    </div>
  }

  <!-- Order and Payment side by side on a wide screen, Feature under Payment
       (or at the top beside Order when Payment is hidden); one column, in
       Order / Feature / Payment order, below that. -->
  @if (nothingToShow) {
    <div class="settings-card state-card">
      <i class="bx bx-cog state-icon"></i>
      <span class="card-title">No Settings Yet</span>
      <span class="card-subtitle">Nothing here is set up for this restaurant yet.</span>
    </div>
  }
  <div class="settings-grid" [class.no-payment]="!showPayment">
    @if (showSwitches || showTogo) {
      <section class="settings-area area-order" aria-labelledby="settings-order">
        <div class="area-heading">
          <span class="area-label" id="settings-order">Order</span>
          <span class="area-desc"
            >How guests place orders: at the table, ahead online, or to go.</span
          >
        </div>
        <div class="settings-card">
          <div class="card-heading">
            <span class="card-title">Ordering</span>
            <span class="card-subtitle">
              Choose how guests can order. Changes apply straight away.
            </span>
          </div>
          @if (showSwitches) {
            <ng-container *ngTemplateOutlet="switches; context: { $implicit: orderRows }" />
          }
          @if (showTogo) {
            <div class="embedded">
              @if (togoLocked) {
                <ng-container *ngTemplateOutlet="planLocked; context: { $implicit: 'To Go' }" />
              } @else {
                <app-togo-setting />
              }
            </div>
          }
        </div>
      </section>
    }

    @if (showSwitches) {
      <section class="settings-area area-feature" aria-labelledby="settings-feature">
        <div class="area-heading">
          <span class="area-label" id="settings-feature">Feature</span>
          <span class="area-desc">Tools that change how your kitchen works.</span>
        </div>
        <div class="settings-card">
          <div class="card-heading">
            <span class="card-title">Kitchen</span>
            <span class="card-subtitle">
              Choose how tickets reach the kitchen. Changes apply straight away.
            </span>
          </div>
          <ng-container *ngTemplateOutlet="switches; context: { $implicit: featureRows }" />
        </div>
      </section>
    }

    @if (showPayment) {
      <section class="settings-area area-payment" aria-labelledby="settings-payment">
        <div class="area-heading">
          <span class="area-label" id="settings-payment">Payment</span>
          <span class="area-desc">The ways customers can pay for their orders.</span>
        </div>
        <app-payment-setting />
      </section>
    }
  </div>
</div>

<!-- One section's switches, or the shared loading / error / empty state. -->
<ng-template #switches let-list>
  @if (loading) {
    <div class="state-inline">
      <img class="state-loading" src="assets/menu_loading.gif" alt="" />
      <span class="card-subtitle">Loading settings, please wait...</span>
    </div>
  } @else if (loadError) {
    <div class="state-inline">
      <i class="bx bx-error-circle state-icon"></i>
      <span class="card-subtitle">{{ loadError }}</span>
      <button type="button" class="retry-btn" (click)="load()">Try Again</button>
    </div>
  } @else if (isEmpty || !list.length) {
    <div class="state-inline">
      <i class="bx bx-cog state-icon"></i>
      <span class="card-subtitle">No settings here are set up for this restaurant yet.</span>
    </div>
  } @else {
    <div class="section">
      @for (row of list; track row.key) {
        <div class="setting-row" [class.unavailable]="!isAvailable(row)">
          <span class="setting-icon"><i class="bx {{ row.icon }}"></i></span>
          <div class="setting-text">
            <span class="setting-title">{{ row.title }}</span>
            <span class="setting-desc">{{ row.description }}</span>
            @if (!isAvailable(row)) {
              <span class="setting-note">Not set up for this restaurant yet</span>
            } @else {
              @switch (lockReason(row)) {
                @case ('pos_not_selected') {
                  <span class="setting-note locked">
                    <i class="bx bx-lock-alt"></i>
                    <a routerLink="/main/hardware">Choose a POS first</a>
                  </span>
                }
                @case ('pos') {
                  <span class="setting-note locked">
                    <i class="bx bx-lock-alt"></i>
                    <a routerLink="/main/hardware">Available with Fork &amp; Find or Clover POS</a>
                  </span>
                }
                @case ('plan') {
                  <span class="setting-note locked">
                    <i class="bx bx-lock-alt"></i>
                    Available on the {{ requiredPlan(row) }} plan and above.
                    <a routerLink="/main/billing-and-subscription">Upgrade</a>
                  </span>
                }
              }
            }
          </div>
          <label class="switch" [class.disabled]="isDisabled(row)">
            <input
              type="checkbox"
              role="switch"
              [checked]="isOn(row)"
              [disabled]="isDisabled(row)"
              (change)="toggle(row, $event)"
              [attr.aria-label]="row.title"
            />
            <span class="slider"></span>
          </label>
        </div>
      }
    </div>
  }
</ng-template>

<!-- A Standard-and-above section on the Free plan, as its sidebar entry was. -->
<ng-template #planLocked let-name>
  <div class="setting-row plan-locked">
    <span class="setting-icon"><i class="bx bx-lock-alt"></i></span>
    <div class="setting-text">
      <span class="setting-title">{{ name }}</span>
      <span class="setting-note locked">
        Available on the Standard plan.
        <a routerLink="/main/billing-and-subscription">Upgrade</a>
      </span>
    </div>
  </div>
</ng-template>
